import { useDispatch } from 'react-redux';

import { Flex, Text } from '@raystack/apsara';
import { clsx } from 'clsx';

import { For } from '@src/hoc';
import { useMapStyle } from '@src/hooks/useMapStyle';
import { setMapType } from '@src/redux/_reducers/mapControl';

import styles from './MapLayers.module.css';

const MapLayers = () => {
  const dispatch = useDispatch();

  const { mapStyles, currentMapStyle } = useMapStyle();

  return (
    <Flex className={styles.mapLayerdiv} gap='medium'>
      <For each={mapStyles}>
        {style => (
          <Flex
            direction='column'
            data-test-id={`map-switch-${style.name}`}
            className={clsx(styles.layer, {
              [styles.selected]: style.name === currentMapStyle.name
            })}
            onClick={() => {
              if (style.name !== currentMapStyle.name) {
                dispatch(setMapType(style.name));
              }
            }}
          >
            <img src={style.thumbnail} alt='Map Style' className={styles.img} />

            <Text size='mini' weight='medium' className={styles.text}>
              {style.name}
            </Text>
          </Flex>
        )}
      </For>
    </Flex>
  );
};

export default MapLayers;
